import { CashbackOfferType } from "../CashbackOfferType";
export function isAffiliatePrimitives(primitives) {
    return primitives.type === CashbackOfferType.AFFILIATE;
}
